const firstTimeModalHomeNewsletter = {
  'first-time-modal-home-title': 'Pandito Newsletter',
  'first-time-modal-home-body': 'Do you want to stay informed, know which events we are attending, and what\'s new with Pandito? Then sign up for our newsletter!',
  'first-time-modal-home-info': 'The newsletter will be sent from this email address: panditoicecream@gmail.com'
};

export default firstTimeModalHomeNewsletter;
